<template>
  <div class="contain" @touchmove.prevent>
    <div class="select">
      <div class="makesure">
        <div class="cancel" @click="cancel">取消</div>
        <div class="sure" @click="sure">确认</div>
      </div>
      <mt-picker :slots="myAddressSlots" @change="onValuesChange"></mt-picker>
      <!-- <mt-picker :slots="slots" @change="onValuesChange"></mt-picker> -->
    </div>
  </div>
</template>
<script>
import { city, privinceList, cityList, districtList } from './city/city'

export default {
  name: 'LocationPicker',
  data () {
    return {
      myprivinceList: [], // 省的数组
      mycityList: [], // 省对应城市的数组
      mydistrictList: [], // 区或者县的数组
      areapicker: '',
      myAddressSlots: [
        {
          flex: 1,
          defaultIndex: 0,
          values: privinceList, // 省份数组
          className: 'slot1',
          textAlign: 'center'
        },
        {
          pider: true,
          content: '-',
          className: 'slot2'

        }, {
          flex: 1,
          defaultIndex: 0,
          values: cityList,
          className: 'slot3',
          textAlign: 'center'
        },
        {
          pider: true,
          content: '-',
          className: 'slot4'
        },
        {
          flex: 1,
          defaultIndex: 0,
          values: districtList,
          className: 'slot5',
          textAlign: 'center'
        }
      ],
      myAddressPrivince: '', // 最后选中的省或直辖市
      myAddressCity: '', // 最后选中的城市
      myAddressDistrict: '' // 最后选中的区或者县
    }
  },
  watch: {
    myAddressPrivince (oldval, newval) { // 省数据变化后，更新市的显示数据
      this.areapicker.setSlotValues(2, this.mycityList)
      this.areapicker.setSlotValue(2, this.mycityList[0])
      // console.log('选中的省是'+this.myAddressPrivince);
    },
    myAddressCity (oldval, newval) { // 城市的值改变后，重置区县的数据
      this.areapicker.setSlotValues(4, this.mydistrictList)
      this.areapicker.setSlotValue(4, this.mydistrictList[0])
      // console.log('选中的市是'+this.myAddressCity);
    },
    myAddressDistrict (oldval, newval) {
      // console.log('选中的区是'+this.myAddressDistrict);
    }

  },
  methods: {
    onValuesChange: function (picker, values) {
      this.areapicker = picker
      this.mycityList = []
      this.mydistrictList = []
      var chooseList = city.filter(function (item) {
        return item.name === values[0]
      })
      if (chooseList[0].sub) {
        for (var item of chooseList[0].sub) {
          this.mycityList.push(item.name)
        }
        // 获取非直辖市数据
        if (chooseList[0].sub.length > 1) {
          var choosedisList = []
          if (this.mycityList.indexOf(values[2]) > -1 && values[2] !== '其他') {
            choosedisList = chooseList[0].sub.filter(function (item) {
              return item.name === values[2]
            })
            for (let item of choosedisList[0].sub) {
              this.mydistrictList.push(item.name)
            }
          } else {
            this.mydistrictList = []
          }
        } else { // 获取直辖市数据
          for (let item of chooseList[0].sub[0].sub) {
            this.mydistrictList.push(item.name)
          }
        }
      }
      this.myAddressPrivince = values[0]
      this.myAddressCity = values[2]
      this.myAddressDistrict = values[4]
    },
    cancel () {
      this.$emit('addressList', false, '', '', '')
    },
    sure () {
      this.$emit('addressList', false, this.myAddressPrivince, this.myAddressCity, this.myAddressDistrict)
    }
  },
  mounted () {
    this.$nextTick(() => { // vue里面全部加载好了再执行的函数 （类似于setTimeout）
      this.myAddressSlots[0].defaultIndex = 0
    })
  }
}
</script>
<style  scoped>
.contain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  overflow: hidden;
}
.select {
  width: 100%;
  height: 43px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 210px;
  background: #fff;
}
.select > .makesure {
  width: 100%;
  height: 43px;
  line-height: 43px;
  background: #f9f9f9;
}

.cancel {
  float: left;
  height: 43px;
  line-height: 43px;
  width: 50px;
  text-align: center;
  font-size: 14px;
}
.sure {
  float: right;
  height: 43px;
  line-height: 43px;
  width: 65px;
  text-align: center;
  font-size: 14px;
  color: #dd2f21;
}
.picker {
  height: 180px;
  -webkit-overflow-scrolling: touch;
}
.picker .picker-slot-wrapper {
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/components/adress_list.vue